import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import theme from "../thema";
import { ThemeProvider } from "@mui/material/styles";
import {
  SharedComponentsThemeProvider,
  type SharedColorPalette,
} from "@ippon/shared-components";
import { formatTheme } from "./theme/formatTheme";
import { AuthProvider } from "@ippon/shared-auth";

const rootElement = document.getElementById("root");

const token =
  typeof window !== "undefined" ? localStorage.getItem("authToken") : null;
const initialUser = token ? { id: "self", name: "persisted" } : null;

if (rootElement) {
  console.log("Creating React root...");
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <SharedComponentsThemeProvider
              colorsOverride={formatTheme.colors as Partial<SharedColorPalette>}
            >
              <AuthProvider initialUser={initialUser}>
                <App />
              </AuthProvider>
            </SharedComponentsThemeProvider>
          </ThemeProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
    console.log("React app rendered");
  } catch (error) {
    console.error("Error rendering app:", error);
  }
} else {
  console.error("Root element not found!");
}
